/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Artifact_Shared_Banner_DescriptionInputs */



/**
* | output |
* | --- |
* | "Shared by {name}. You can edit this artifact or create your own copy." |
*
* @param {Artifact_Shared_Banner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_shared_banner_description = /** @type {((inputs: Artifact_Shared_Banner_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Shared_Banner_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Geteilt von ${i?.name}. Sie können dieses Artefakt bearbeiten oder eine eigene Kopie erstellen.`)
	return /** @type {LocalizedString} */ (`Shared by ${i?.name}. You can edit this artifact or create your own copy.`)
});